"use client";

import { useTranslations } from "next-intl";

import { cn } from "@workspace/sc-ui/lib/utils";

type BrandLockupProps = {
  className?: string;
  compact?: boolean;
};

/** Typograficzny znak wariantu A; kwadrat jest dekoracją, nie częścią nazwy. */
export function BrandLockup({ className, compact = false }: BrandLockupProps) {
  const tBrand = useTranslations("app.brand");

  return (
    <div className={cn("app-brand", className)} data-compact={compact} data-testid="brand-lockup">
      <span>{tBrand("title")}</span>
      <span className="app-brand-square" aria-hidden="true" />
    </div>
  );
}
